import {xdm} from './xdmApi';

const xdmRegp = /xdm/g;
const n = window.navigator.userAgent;
if (!xdmRegp.test(n)) {
  // alert('请在小豆苗APP中打开！');
}

// 导出合并之后的接口
export default xdm;



// WEBPACK FOOTER //
// ./src/js/native/index.js